import React, { useCallback, useContext, useState } from "react";

import { faCaretDown, faCaretUp } from "@awesome.me/kit-4c83d50d0d/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import { Views } from "~/actionItems/constants";
import { ActionItemsContext } from "~/actionItems/newActionItems/ActionItemsContext";
import { useRealAiActionItemsIsOn } from "~/meetingRecorder/utils";
import Menu from "~/ui/menu";

import styles from "./Filters.module.css";

export default function GroupBy() {
	const { filters, view } = useContext(ActionItemsContext);
	const {
		showCompleted,
		onToggleShowCompleted,
		showWontDo,
		onToggleShowWontDo,
		showCreatedByYou,
		onToggleShowCreatedByYou,
		showRecentOnly,
		onToggleShowRecentOnly,
		showAIDetected,
		onToggleShowAIDetected,
	} = filters;

	const [isOpen, setIsOpen] = useState<boolean>(false);

	const toggleOpen = useCallback(() => setIsOpen(isOpen => !isOpen), []);

	const isRealActionItemsFeatureFlagOn = useRealAiActionItemsIsOn();

	return (
		<Menu open={isOpen} onOpenChange={toggleOpen}>
			<Menu.Trigger>
				<button className={cx(styles.filterButton, { [styles.active]: isOpen })}>
					Filters
					<FontAwesomeIcon icon={isOpen ? faCaretUp : faCaretDown} />
				</button>
			</Menu.Trigger>
			<Menu.Content>
				<Menu.SwitchItem checked={showCompleted} onCheckedChange={onToggleShowCompleted}>
					Show completed
				</Menu.SwitchItem>
				<Menu.SwitchItem checked={showWontDo} onCheckedChange={onToggleShowWontDo}>
					Show archived
				</Menu.SwitchItem>
				{isRealActionItemsFeatureFlagOn && (
					<Menu.SwitchItem checked={showAIDetected} onCheckedChange={onToggleShowAIDetected}>
						Show AI-Detected
					</Menu.SwitchItem>
				)}
				{view === Views.TEAMMATES && (
					<>
						<Menu.SwitchItem checked={showCreatedByYou} onCheckedChange={onToggleShowCreatedByYou}>
							Only created by you
						</Menu.SwitchItem>
						<Menu.SwitchItem checked={showRecentOnly} onCheckedChange={onToggleShowRecentOnly}>
							Only created in the last 30 days
						</Menu.SwitchItem>
					</>
				)}
			</Menu.Content>
		</Menu>
	);
}
